import type { DescriptionsProps } from 'antd'
import {
  Descriptions,
  Spin,
} from 'antd'
import * as Cesium from '@cesiumgs/cesium-analytics'
import { Cartographic } from '@cesiumgs/cesium-analytics'
import * as turf from '@turf/turf'

import './FacilityAroundTabs.less'
import { observer } from 'mobx-react'
import {
  useEffect,
  // useEffect,
  useState,
} from 'react'
import {
  queryIntersects,
} from '@/service/rightNavCtrl'
import useStore from '@/hooks/useStore'

let polygonDataSource: any = null
let circlePolygon: any = null // 원의 폴리곤 정보
// let circleCount = 0 // 화면에 표시된 원의 개수

function FacilityAroundTabs() {
  const landRatioArr = [
    { name: '논', value: ['1110', '1120'], area: 0, ratio: '' },
    { name: '밭', value: ['1210', '1220'], area: 0, ratio: '' },
    { name: '초지', value: ['2110', '2120'], area: 0, ratio: '' },
    { name: '입목지', value: ['2210', '2220', '2230'], area: 0, ratio: '' },
    { name: '임지-기타', value: ['2310', '2320', '2330', '2340'], area: 0, ratio: '' },
    { name: '주거지 및 상업지', value: ['3110', '3120', '3130', '3140'], area: 0, ratio: '' },
    { name: '교통시설', value: ['3210', '3220', '3230', '3240'], area: 0, ratio: '' },
    { name: '공업지', value: ['3310', '3320'], area: 0, ratio: '' },
    { name: '공공시설물', value: ['3410', '3420', '3430', '3440'], area: 0, ratio: '' },
    { name: '기타시설', value: ['3510', '3520', '3530', '3540', '3550'], area: 0, ratio: '' },
    { name: '습지', value: ['4110', '4120'], area: 0, ratio: '' },
    { name: '하천', value: ['4210'], area: 0, ratio: '' },
    { name: '호소', value: ['4310', '4320'], area: 0, ratio: '' },
    { name: '수계-기타', value: ['4410'], area: 0, ratio: '' },
  ]

  const facilityStore = useStore('facilityStore')
  const [resultShow, setResultShow] = useState(true)
  const [Loading, setLoading] = useState(true)
  const [tableItems, setTableItems] = useState<DescriptionsProps['items']>([])
  const [contentArr, setContentArr] = useState<any>(landRatioArr)

  useEffect(() => {
    if (facilityStore.clickedLonLat) {
      polygonDataSource = new Cesium.CustomDataSource('dataSourceLayer')
      window.cviewer.dataSources.add(polygonDataSource)
      const { clickedLonLat = [] } = facilityStore
      const cartesian3 = Cesium.Cartesian3.fromDegrees(clickedLonLat[0], clickedLonLat[1]) || ''
      if (cartesian3) {
        calcLandRatio(cartesian3)
      }
    }
  }, [facilityStore.clickedLonLat])

  useEffect(() => {
    setLoading(true)
    setTableItems([])
    facilityStore.queryEnvironmentInfo().then((res: any) => {
      if (res.code === 200) {
        const data = res.result
        setTableItems([
          {
            key: '1',
            label: '주변 축사',
            children: `${Math.floor(data.danimDistance).toLocaleString()}m`,
            span: 24,
          },
          {
            key: '2',
            label: '주차장',
            children: `${data.prkplceCnt}개`,
            span: 24,
            contentStyle: { width: 400 },
          },
          {
            key: '3',
            label: '행위제한',
            children: `${data.areaGu}`,
            span: 24,
            contentStyle: { width: 400 },
          },
        ])
        setLoading(false)
      }
      else {
        setLoading(false)
        setResultShow(false)
      }
    })
  }, [facilityStore.FacilityLeaseInfo])

  /**
   * 테스트 코드 - 토지이용현황도 선택 후 바탕을 클릭하면 반경에 해당하는 원을 그리고 면적을 계산
   */
  const calcLandRatio = (obj: any) => {
    if (!obj)
      return
    if (obj) {
      const position = obj
      if (position) {
        const cartographic = Cartographic.fromCartesian(position)
        const lng = Cesium.Math.toDegrees(cartographic.longitude)
        const lat = Cesium.Math.toDegrees(cartographic.latitude)
        const center = [lng, lat]
        const radius = 0.5
        const circle = turf.circle(center, radius, { steps: 10, units: 'kilometers', properties: { foo: 'bar' } })
        circlePolygon = circle
        circle.geometry.coordinates.forEach((item2: any, index2: number) => {
          let pointArr: any = []
          const pointArr2: any = []
          item2.forEach((element: any, index3: number) => {
            pointArr = element.flat(3)
            pointArr2.push(pointArr[0])
            pointArr2.push(pointArr[1])
          })
          // const position = new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(pointArr2))
          // let addEntity: any = null
          // addEntity = new Cesium.Entity({
          //   id: `111_${circleCount++}`,
          //   name: 'circle',
          //   polygon: {
          //     hierarchy: position,
          //     material: new Cesium.ColorMaterialProperty(Cesium.Color.RED),
          //     heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          //   },
          //   polyline: {
          //     positions: position.positions,
          //     width: 2,
          //     material: Cesium.Color.WHITE.withAlpha(0.3),
          //     clampToGround: true,
          //   },
          // })
          // polygonDataSource.entities.add(addEntity)
        })
      }

      // 전북 전체 지역 정보 중 circle과 겹치는 polygon 검색
      queryIntersects(circlePolygon).then((res: any) => {
        const landRatio = JSON.parse(JSON.stringify(landRatioArr)) // 대시 비율 계산 배열
        let totalArea = 0 // 면적 합
        // 특정 레이어에서 circle과 겹치는 polygon 검색
        res.features.forEach((item: any, index2: number) => {
          const ucbPolygon = turf.polygon(item.geometry.coordinates[0])
          const inter = turf.intersect(circlePolygon, ucbPolygon)
          if (inter != null) {
            // 겹치는 부분의 면적 계산 (제곱미터)
            const calcArea = turf.area(inter)
            for (let i = 0; i < landRatio.length; i++) {
              const lrItem = landRatio[i]
              if (lrItem.value.includes(item.properties.UCB)) {
                lrItem.area += calcArea
                totalArea += calcArea
              }
            }

            // 겹치는 부분을 화면에 표시
            // inter.geometry.coordinates.forEach((item2: any, index2: number) => {
            //   let pointArr: any = []
            //   const pointArr2: any = []
            //   item2.forEach((element: any, index3: number) => {
            //     pointArr = element.flat(3)
            //     pointArr2.push(pointArr[0])
            //     pointArr2.push(pointArr[1])
            //   })
            //   const position = new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(pointArr2))
            //   let addEntity: any = null
            //   addEntity = new Cesium.Entity({
            //     id: `111_${circleCount++}`,
            //     name: 'circle',
            //     polygon: {
            //       hierarchy: position,
            //       material: new Cesium.ColorMaterialProperty(Cesium.Color.BLUEVIOLET),
            //       heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            //     },
            //     polyline: {
            //       positions: position.positions,
            //       width: 2,
            //       material: Cesium.Color.WHITE.withAlpha(0.3),
            //       clampToGround: true,
            //     },
            //   })
            //   polygonDataSource.entities.add(addEntity)
            // })
          }
        })

        // area 값이 있는 항목의 비율 계산
        for (let i = 0; i < landRatio.length; i++) {
          const lrItem = landRatio[i]
          if (lrItem.area === 0)
            lrItem.ratio = '00%'
          else
            lrItem.ratio = `${(lrItem.area / totalArea * 100).toFixed(2)}%`
        }
        setContentArr(landRatio)
        setLoading(false)
      })
    }
  }

  const renderContent = () => {
    return (
      <div className={'tablePart-content'}>
        <header>주변 대지 비율</header>
        {contentArr.map((item: any, index: number) => {
          return <ul className={'tablePart-content-item'} key={index}>
            <li className={'tablePart-content-item-title'}>{item.name}</li>
            <li className={'tablePart-content-item-value'}>{item.ratio}</li>
          </ul>
        })}
      </div>
    )
  }

  return (
    <div className={'FacilityAroundTabs'}>
      {
                resultShow
                  ? (
                        <Spin tip="검색..." size="large" spinning={Loading}>
                            <div className={'tablePart'}>
                               <div className={'tbl-wrap-title'}>
                                    <strong>주변환경</strong>
                                     <a>
                                     축사 : 가장 가까운 곳(최대 10km),&nbsp;&nbsp;
                                    주차장 : 반경 2km</a>
                                    </div>
                                <Descriptions size={'small'} bordered items={tableItems}/>
                            </div>
                        </Spin>
                    )
                  : (
                        <div className={'not-info'}>
                              결과가 없습니다.
                        </div>
                    )
            }
        <Spin tip="검색..." size="large" spinning={Loading}>
        <div className={'tablePart'}>
          {/* <header>주변 대지 비율</header> */}
          <div className={'tbl-wrap-title'}>
          <strong style={{ marginRight: '380px' }}>주변 대지 비율</strong>
            <a>반경 500m</a>
          </div>
          {/* <Descriptions title="주변 대지 비율" size={'small'} bordered items={tableItems}/> */}
          {renderContent()}
        </div>
        </Spin>
    </div>
  )
}
export default observer(FacilityAroundTabs)
